
<template>
  <div v-if="ready">
    <!-- adfadf -->
    <div v-for="f in Object.keys(custom_value.content)" :key="f">
      <!-- {{ f }} -->
      <v-text-field v-if="!hasMask(f)" v-model="custom_value.content[f]" prepend-icon="mdi-information" :label="setLabel(f)" color="secondary"></v-text-field>
      <v-text-field v-if="hasMask(f)" v-model="custom_value.content[f]" v-mask="setMask(f)" :placeholder="setMask(f)" prepend-icon="mdi-information" :label="setLabel(f)" color="secondary"></v-text-field>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'

export default {
  directives: {
    mask,
  },
  props: {
    custom_value: {
      type: Object,
    },
    field_settings:{
      type: Object,
    }
  },
  data() {
    return {
      ready: true,
      aux_cv: {
        custom_field_id: null,
        content: {}
      },
      // field_settings: {},

      masks:[
        {id: 1, text: 'Telefone - (##)####-####', value: '(##)####-####'},
        {id: 2, text: 'Celular - (##)#-####-####', value: '(##)#####-####'},
        {id: 3, text: 'CPF - ###.###.###-##', value: '###.###.###-##'},
        {id: 4, text: 'CNPJ - ##.###.###/####-##', value: '##.###.###/####-##'},
      ]
    }
  },
  methods: {
    setupCV() {
      for (const key in this.oneCustomField.fields) {
        if (this.oneCustomField.fields.hasOwnProperty(key)) {
          const element = this.oneCustomField.fields[key];
          this.custom_value.content[element.key] = ''
          this.field_settings[element.key] = {...element}
        }
      }
      this.custom_value.custom_field_id = this.oneCustomField.id
      this.ready = true
    },
    setLabel(field_uuid){
      let fs = null
      if (Object.values(this.field_settings).find(f => f.uuid == field_uuid)){
        fs = Object.values(this.field_settings).find(f => f.uuid == field_uuid)
      } else {
        console.log(field);
      }
      return fs.key
    },
    setMask(field_uuid){
      let fs = null
      if (Object.values(this.field_settings).find(f => f.uuid == field_uuid)){
        fs = Object.values(this.field_settings).find(f => f.uuid == field_uuid)
      } else {
        console.log(field);
      }
      if (fs.settings && (fs.settings.mask_value || fs.settings.mask_id)){
        if (fs.settings.mask_id){
          return this.masks.find(m=>m.id == fs.settings.mask_id).value
        } else if (fs.settings.mask_value){
          return fs.settings.mask_value
        }
      } else{
        return 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
      }
    },
    hasMask(field_uuid){
      let fs = null
      if (Object.values(this.field_settings).find(f => f.uuid == field_uuid)){
        fs = Object.values(this.field_settings).find(f => f.uuid == field_uuid)
      } else {
        console.log(field_uuid);
      }
      return (fs.settings && (fs.settings.mask_value || fs.settings.mask_id))
    },
    ...mapActions({
      // function: 'Module/action'
    }),
    
  },
  mounted () {
    // this.setupCV();
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      oneCustomField: state => state.CustomField.oneCustomField,
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>